import ContactUs from "./components/contact-us/ContactUs";
import Experience from "./components/experience/Experience";
import Footer from "./components/footer/Footer";
import Header from "./components/header/Header";
import Hero from "./components/hero/Hero";
import Projects from "./components/projects/Projects";
import ScrollToTopButton from "./components/scroll-to-top/ScrollTopButton";
import Tech from "./components/tech/Tech";

const App = () => {
  return (
    <>
      <ScrollToTopButton />
      <Header />
      <Hero />
      <Tech />
      <Experience />
      <Projects />
      <ContactUs />
      <Footer />
    </>
  );
};

export default App;
